import { makeStyles } from '@mui/styles';

const useStyles = makeStyles((theme) => ({
  container: ({ variant }) => ({
    ...theme.eatclub.typography.heading[variant],
  }),
}));

export default useStyles;
